import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3091 2.03662C14.878 2.03662 18.5815 5.74018 18.5815 10.3091C18.5815 14.878 14.878 18.5815 10.3091 18.5815C5.74018 18.5815 2.03662 14.878 2.03662 10.3091C2.03662 5.74018 5.74018 2.03662 10.3091 2.03662Z",
			stroke: "currentColor",
			strokeWidth: 1.45455
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 9.81836,
			width: 2.61818,
			height: 1.30909,
			rx: .654545,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 9.81836,
			width: 2.61818,
			height: 1.30909,
			rx: .654545,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.49072,
			y: 20.6182,
			width: 2.61818,
			height: 1.30909,
			rx: .654545,
			transform: "rotate(-90 9.49072 20.6182)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.49072,
			y: 2.61816,
			width: 2.61818,
			height: 1.30909,
			rx: .654545,
			transform: "rotate(-90 9.49072 2.61816)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4593 10.3082C13.4593 12.048 12.0489 13.4583 10.3092 13.4583C8.5695 13.4583 7.15918 12.048 7.15918 10.3082C7.15918 8.56853 8.5695 7.1582 10.3092 7.1582C12.0489 7.1582 13.4593 8.56853 13.4593 10.3082ZM8.55221 10.3082C8.55221 11.2786 9.33885 12.0653 10.3092 12.0653C11.2796 12.0653 12.0662 11.2786 12.0662 10.3082C12.0662 9.33788 11.2796 8.55123 10.3092 8.55123C9.33885 8.55123 8.55221 9.33788 8.55221 10.3082Z",
			fill: "currentColor"
		})
	]
});
export default SvgShot;
